import React from "react";
import { Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/constants/brand";

export default function ContactSection() {
    return (
        <section
            data-testid="contact-section"
            id="contact"
            className="py-14 bg-cream border-t border-forest-100"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left max-w-3xl">
                    <ContactCard
                        icon={Mail}
                        title="Email Us"
                        sub="24/7 order inquiries"
                        link={`mailto:${CONTACT.email}`}
                        label={CONTACT.email}
                    />
                    <ContactCard
                        icon={MapPin}
                        title="Official Distribution"
                        sub="Resham Drops Pakistan Hub"
                        label="Lahore & Karachi Logistics Centers"
                    />
                </div>
            </div>
        </section>
    );
}

function ContactCard({ icon: Icon, title, sub, link, label, external }) {
    return (
        <div className="space-y-2">
            <div className="w-11 h-11 rounded-full bg-forest-800 text-gold-400 flex items-center justify-center mx-auto md:mx-0">
                <Icon className="w-5 h-5" />
            </div>
            <h3 className="font-bold text-forest-900 text-base">{title}</h3>
            <p className="text-xs text-forest-700/80">{sub}</p>
            {link ? (
                <a
                    href={link}
                    target={external ? "_blank" : undefined}
                    rel={external ? "noreferrer" : undefined}
                    className="text-xs font-bold text-forest-700 hover:text-gold-600 hover:underline block"
                >
                    {label}
                </a>
            ) : (
                <span className="text-xs text-forest-800 font-medium block">
                    {label}
                </span>
            )}
        </div>
    );
}
